





























































































































































































































































import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from '@vue/composition-api';
import i18n from '@/i18n';
import sl from '@/serviceLocator';
import { Locale } from '@oare/types';

export default defineComponent({
  name: 'OareAppBar',
  setup(_, context) {
    const actions = sl.get('globalActions');
    const router = sl.get('router');
    const store = sl.get('store');
    const server = sl.get('serverProxy');

    const title = computed(() => {
      if (context.root.$vuetify.breakpoint.smAndDown) {
        return 'OARE';
      }
      return i18n.t('appBar.oare');
    });

    const displayAdminBadge = computed(() =>
      Object.values(store.getters.displayAdminBadge).includes(true)
    );

    const isAdmin = computed(() => store.getters.isAdmin);
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const firstName = computed(() =>
      store.getters.user ? store.getters.user.firstName : ''
    );
    const isDevelopmentEnvironment = computed(
      () => process.env.NODE_ENV === 'development'
    );
    const isReadOnlyEnvironment = ref(false);

    const canViewWords = computed(() => store.hasPermission('WORDS'));
    const canViewNames = computed(() => store.hasPermission('NAMES'));
    const canViewPlaces = computed(() => store.hasPermission('PLACES'));
    const canViewPersons = computed(() => store.hasPermission('PERSONS'));
    const canViewBibliography = computed(() =>
      store.hasPermission('BIBLIOGRAPHY')
    );
    const canViewSeals = computed(() => store.hasPermission('SEALS'));
    const canViewPeriods = computed(() => store.hasPermission('PERIODS'));

    const logout = () => {
      store.logout();
      router.push('/login');
      server.logout();
    };

    const locales = ref<Locale[]>([
      { label: 'English', value: 'en' },
      { label: 'Türkçe', value: 'tr' },
    ]);

    const selectedLocale = ref<Locale>(
      locales.value.find(locale => locale.value === i18n.locale) ||
        locales.value[0]
    );

    const setLocale = (locale: Locale) => {
      selectedLocale.value = locale;
      localStorage.setItem('locale', selectedLocale.value.value);
      router.go(0);
    };

    onMounted(async () => {
      try {
        isReadOnlyEnvironment.value = await server.getReadOnlyStatus();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading environment info',
          err as Error
        );
      }
    });

    return {
      title,
      logout,
      isAdmin,
      isAuthenticated,
      firstName,
      displayAdminBadge,
      isDevelopmentEnvironment,
      isReadOnlyEnvironment,
      canViewWords,
      canViewNames,
      canViewPlaces,
      canViewPersons,
      canViewBibliography,
      canViewSeals,
      canViewPeriods,
      i18n,
      locales,
      selectedLocale,
      setLocale,
    };
  },
});
